// @flow

import storageAvailable from 'storage-available';

//
// AuthState stores the state for authing
// it does not and should not know about how to
// interact with its contents,
// it just stores them
//

export default class AuthState<State> {

    localStorageKey: string = 'BlueflagAuthState';
    useLocalStorage: boolean = false;
    onChangeCallback: Function = () => {};

    initialState: State;
    defaultState = {
        accessToken: '',
        refreshToken: '',
        idToken: '',
        tokenExpiry: 0,
        authEndpoint: null,
        redirectPath: undefined,
        clientPath: '/',
        isSignedIn: false
    };
    state: State;

    constructor({initialState}: {defaultState: State, initialState: State|undefined}) {
        // save initialState to a member variable so we can roll back to it in case of unparseable JSON in localstorage
        this.initialState = initialState || {};
        this.useLocalStorage = storageAvailable('localStorage');
        const newState = this.useLocalStorage
            ? this._getLocalStorageState()
            : {...this.defaultState, ...this.initialState};
        this.set({
            ...newState,
            tokenExpiry: 0 // force a refresh token on inital load, to update permissions
        });
    }

    //
    // private methods
    //

    _parseState = (str: string): State => {
        try {
            let result = JSON.parse(str);

            return {
                ...this.defaultState,
                ...result,
                ...this.initialState
            };

        } catch(e) {

            return {
                ...this.defaultState, 
                ...this.initialState
            };
        }
    };

    _getLocalStorageState = (): State => {
        let stringified: string = localStorage.getItem(this.localStorageKey) || '';
        return this._parseState(stringified);
    };

    //
    // public methods
    //

    get = (): State => {
        return this.state;
    };

    set = (newState: State): State => {
        if(this.useLocalStorage) {
            try {
                localStorage.setItem(this.localStorageKey, JSON.stringify(newState));
            } catch(e) {
                // do nothing, memory state will still be updated
            }
        }

        this.state = newState;
        this.onChangeCallback(newState);

        return newState;
    };

    merge = (newState: State): State => {
        let currentState: State = this.get();

        return this.set({
            ...currentState,
            ...newState
        });
    };

    resetState = () => {
        return this.merge(this.defaultState);
    }
    //
    // onChange
    // registers an onChange callback
    //

    onChange = (callback: Function) => {
        this.onChangeCallback = callback;
    };

}
